module.exports = " <header class=onboarding-header> <div class=onboarding-header__top> <div class=\"_wrapper onboarding-header__container\"> <div class=onboarding-header__logo-container> <a href=\"{{siteUrl}}/\"> <svg class=onboarding-header__logo> <use xlink:href=#goldmoney-logo-22></use> </svg> </a> </div> <a href=\"{{supportUrl}}\" class=h-default-link translate> Support </a> </div> </div> </header>";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/directives/onboarding-header/onboarding-header.html
// module id = 962
// module chunks = 0